import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { use_effect } from '@/hooks/_base/use_effect';
import { MutableRefObject, ReactNode, useState } from 'react';

interface Props {
  children: ReactNode;
  length: number;
  ref_trigger: MutableRefObject<HTMLDivElement | null>;
  isDropdownOpen: boolean;
}

export function BarGrid2dViewersDropdown({ children, ref_trigger, isDropdownOpen, length }: Props) {
  const [trigger_width, set_trigger_width] = useState(0);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (!ref_trigger.current) return;
    const rect = ref_trigger.current.getBoundingClientRect();
    set_trigger_width(rect.width);
  }, [ref_trigger, isDropdownOpen]);

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__dropdown_menu open={isDropdownOpen}>
      <UI_PRIMITIVE__dropdown_menu_trigger asChild>
        <div
          className="cursor-pointer w-5 h-5 flex items-center justify-center text-sm rounded-full bg-component hover:bg-component-item"
          title={`Show ${length} more`}
        >
          +{length}
        </div>
      </UI_PRIMITIVE__dropdown_menu_trigger>

      <UI_PRIMITIVE__dropdown_menu_content
        className="rounded-lg !bg-bar !shadow-md !border-none p-0"
        side="top"
        align="end"
        style={{ width: trigger_width || 'auto', transform: `translateX(${8}px)` }}
      >
        {children}
      </UI_PRIMITIVE__dropdown_menu_content>
    </UI_PRIMITIVE__dropdown_menu>
  );
}
